import { NgModule } from '@angular/core';
import { CommonModule, TitleCasePipe } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatButtonModule } from '@angular/material/button';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatIconModule } from '@angular/material/icon';
import { MatSelectModule } from '@angular/material/select';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { TranslateModule } from '@ngx-translate/core';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';

import { SeSmartTextEditorComponent } from './se-smart-text-editor/se-smart-text-editor.component';
import { SeSuggestionSelectorComponent } from './se-suggestion-selector/se-suggestion-selector.component';
import { SeUiDefaultTextComponent } from './se-ui-default-text/se-ui-default-text.component';
import { SeTextEditorMenuItemComponent } from './se-text-editor-menu-item/se-text-editor-menu-item.component';
import { SeTextEditorMenuToggleGroupComponent } from './se-text-editor-menu-toggle-group/se-text-editor-menu-toggle-group.component';
import { SeSuggestionSelectorOverlayComponent } from './se-suggestion-selector-overlay/se-suggestion-selector-overlay.component';
import { SeTextEditorMenuSelectComponent } from './se-text-editor-menu-select/se-text-editor-menu-select.component';
import { SeTextEditorComponent } from './se-text-editor/se-text-editor.component';
import { MatExpansionModule } from '@angular/material/expansion';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatCardModule } from "@angular/material/card";
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatRadioModule } from '@angular/material/radio';

@NgModule({
    declarations: [
        SeTextEditorComponent,
        SeSmartTextEditorComponent,
        SeSuggestionSelectorComponent,
        SeTextEditorMenuItemComponent,
        SeTextEditorMenuToggleGroupComponent,
        SeSuggestionSelectorOverlayComponent,
        SeTextEditorMenuSelectComponent,
        SeUiDefaultTextComponent
    ],
    imports: [
        CommonModule,
        FormsModule,
        MatButtonModule,
        MatButtonToggleModule,
        MatCheckboxModule,
        MatIconModule,
        MatSelectModule,
        MatSnackBarModule,
        TranslateModule,
        MatExpansionModule,
        DragDropModule,
        MatSlideToggleModule,
        TitleCasePipe,
        MatTooltipModule,
        MatCardModule,
        MatFormFieldModule,
        MatInputModule,
        MatRadioModule
    ],
    exports: [
        SeSmartTextEditorComponent,
        SeSuggestionSelectorOverlayComponent,
        SeUiDefaultTextComponent,
        SeTextEditorComponent
    ],
    providers: [
        TitleCasePipe
    ],
    bootstrap: [],
})
export class SeUiTextEditorModule { }
